import {
  track as trackEvent,
  EventTypes,
  Actions,
  adPartnersTo,
} from '@mc/track-event'
import { LoginMethod } from './utils/lastLoginMethod'

export interface ExperimentTrackingProps {
  loginMethod?: LoginMethod
  lastLoginMethod?: LoginMethod | null
}

const getIntegrations = (value: boolean = true) => ({
  ...adPartnersTo(value),
  Hotjar: false,
})

const track = (
  event: string,
  properties: Record<
    string,
    string | number | boolean | object | null | undefined
  >,
  options: { integrations?: Record<string, boolean> } = {
    integrations: getIntegrations(false),
  },
) => {
  trackEvent(event, properties, options)
}

/**
 * Track when user clicks a sign-in button
 */
export const trackSignInClicked = (
  props: ExperimentTrackingProps & {
    action?: string
  },
) => {
  track(EventTypes.LOG_IN_MODAL_CTA_CLICKED, {
    action: props.action || Actions.LOG_IN,
    login_method: props.loginMethod,
    last_login_method: props.lastLoginMethod || null,
  })
}

/**
 * Track successful sign-in
 */
export const trackSignedIn = (props: ExperimentTrackingProps) => {
  track(EventTypes.SIGNED_IN, {
    login_method: props.loginMethod,
    last_login_method: props.lastLoginMethod || null,
    location: 'modal',
  })
}

/**
 * Track when user clicks forgot password
 */
export const trackForgotPasswordClicked = (
  props: ExperimentTrackingProps = {},
) => {
  track(EventTypes.LOG_IN_MODAL_CTA_CLICKED, {
    action: Actions.FORGOT_PASSWORD_CTA,
    last_login_method: props.lastLoginMethod || null,
  })
}
